import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { LogEntry, LogEntrySuccess } from './log.action';
import { LogService } from './log.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { environment } from '../../../../../projects/administration/src/environments/environment';

// export class PositionPanelModel {sidebarShown: any; topbarShown: any; }
// export class StatePanelModel {sidebarShown: any; topbarShown: any; side: string; userstate: string; }

export interface ILogStateModel {
    // logState: string;
    state: any; // StatePanelModel; // {sidebarShown: boolean, topbarShown: boolean, side: string, userstate: string}
}

@State<ILogStateModel>({
    name: 'logState',
    defaults: {
        state: '' // {sidebarShown: false, topbarShown: false, side: '', userstate: ''}
    }
})

@Injectable()

export class LogState {

    constructor(
                // private router: Router,
                // private _cookieService: CookieService,
                // private _authenticationService: AuthenticationService,
                private store: Store,
                private logService: LogService
                ) { }

    @Action(LogEntry)
    saveLogEntry(
        context: StateContext<ILogStateModel>,
        action: LogEntry
     ) {
        this.logService.SaveLogError(action.entry).subscribe( ret => {
            // if ret.success
            context.dispatch(new LogEntrySuccess('Saved'));
        });

    }

    @Action(LogEntrySuccess)
    saveLogEntrySuccess(
        context: StateContext<ILogStateModel>,
        action: LogEntrySuccess
    ) {
        context.setState({
            state: 'LogEntry - Success' // {sidebarShown: false, topbarShown: false, side: '', userstate: ''}
        });

        // this.router.navigate(['/login']);
        // window.location.reload();
    }


}
